<div class="line _main">
    <div class="mkt_col _controls" [class.bg-white]="!isSubitem" *ngIf="!isSubitem">
        <!-- <button class="bg-dark"><i class="fa fa-download"></i></button>
        <button class="bg-dark"><i class="fa fa-print"></i></button> -->
    </div>
    <div class="mkt_col p-0" [class.bg-white]="!isSubitem"><input placeholder="+ {{!isSubitem ? 'Nueva tarea' : 'Agregar Elemento'}}" class="form-control" type="text"
        (change)="change(newInput.value); newInput.value = ''" #newInput></div>
</div>